module.exports = __webpack_public_path__ + "static/media/wirebasket.436393f0.png";